import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';

import ReactImageFallback from "react-image-fallback";
import {priceName} from './helper'
import loadingImage from "./assets/loading.gif";
import defaultReataurant from "./assets/defaultReataurant.png";
import sprite from "./assets/sprite.png";

import './RestaurantsItems.css';


class RestaurantsItems extends Component {

	render() {

		const restaurants = this.props.restaurantsSelected;

		const berlingskeRating = function(rating){

			let yPos = (rating * 15)-(6*15)

			return (rating !== null && rating !== 0) ?
			( 	<div className='Review'>
					<span className='ReviewLabel'>Berlingske</span>
					<div value={rating} style={{
						backgroundImage: `url(${sprite})`,
						backgroundPositionX: '0px',
						backgroundPositionY: `${yPos}px`,
						width: '100px',
						height: '15px',
					}} ></div>
				</div>
			) :
			''
		}
		const politikenRating = function(rating){
			let yPos = (rating * 15)-(6*15)
			return (rating !== '0' && rating !== 0) ?
			( 
				<div className='Review'>
					<span className='ReviewLabel'>Politiken</span>
					<div value={rating} style={{
						backgroundImage: `url(${sprite})`,
						backgroundPositionX: '-105px',
						backgroundPositionY: `${yPos}px`,
						width: '100px',
						height: '15px',
					}} ></div>
				</div>
			) :
			''
		}
		const whiteGuideRating = function(rating){
			let yPos = null
			let height = 44
			let diff = 42
			if (rating > 90) {
				yPos = 0
			} else if (rating > 80){
				yPos = -(diff * 1)
			} else if(rating > 70){
				yPos = -(diff * 2 )
			} else if (rating > 60){
				yPos = -(diff * 3 )
			} else if (rating > 50 ){
				yPos = -(diff * 4 )-2
				height = 22
			}
			return (rating !== undefined) ?
			( 	
				<div className='Review'>
					<span className='ReviewLabel'>White Guide</span>
					<div value={rating} className='whiteGuide' style={{
						backgroundImage: `url(${sprite})`,
						backgroundPositionX: '-303px',
						backgroundPositionY: `${yPos}px`,
						width: '42px',
						height: `${height}px`,
					}} ><span className='whiteGuideNumber'>{(rating > 60) ? rating : ''}</span></div>
				</div>
			) :
			''
		}
		const michelinRating = function(rating){

			let yPos = null
			let diff = 32
			let height = 33
			if (rating === 'Michelin Plate') {
				yPos = -(diff * 4)
				height = 40
			} else if (rating === 'Bib Gourmand'){
				yPos = -(diff * 3)
				height = 34
			} else if(rating === '1'){
				yPos = -(diff * 2)
			} else if (rating === '2'){
				yPos = -(diff * 1)
			} else if (rating === '3'){
				yPos = 0
			}

			return (yPos !== null) ?
			( 
				<div className='Review'>
					<span className='ReviewLabel'>Michelin</span>
					<div value={rating} style={{
						backgroundImage: `url(${sprite})`,
						backgroundPositionX: '-210px',
						backgroundPositionY: `${yPos}px`,
						width: '90px',
						height: `${height}px`,
					}} ></div>
				</div>
			) :
			''
		}
	
		const restaurantItems = restaurants.map((restaurant, i) =>

				<Col xs={12} sm={12} md={6} lg={4} className='MainItem' key={i}>
					<div className='MainItemInner'>
						<span className='MainItemNumber'>{restaurant.rating}</span>
						<h3 className='MainItemHeadline'>
							{restaurant.title}
							
						</h3>
						<Row>
							<Col xs={4} >
								<div style={{marginLeft:'10px', marginBottom:'10px'}}>
									<ReactImageFallback
										src= { (restaurant.image && restaurant.image.url ) ? restaurant.image.url : 'loader.gif' }
										fallbackImage={defaultReataurant}
										initialImage={loadingImage}
										alt="cool image should be here"
										className='MainItemImage'
									/>
								</div>
							</Col>
							<Col xs={8} >
								<div className='MainItemTag'>{restaurant.area.name}</div>{' '}
								{priceName(restaurant.price)}								

								
								{politikenRating(restaurant.PolitikenRating)}
								
								{berlingskeRating(restaurant.BerlingskeRating)}

								{michelinRating(restaurant.Michelin)}

								{whiteGuideRating(restaurant.WhiteGuideRating)}
								
							</Col>
						</Row>
					</div>

					
				</Col>

		);


		if (restaurants.length === 0) {
			return (
				<div className='MainItems'>
				<Grid fluid>
					<Row>
						<div style={{textAlign:'center',marginTop:'100px'}}></div>
					</Row>
				</Grid>
			</div>
			)
			
		}

		return (

			<div className='MainItems'>
				<Grid fluid>
					<Row>
						{restaurantItems}
					</Row>
				</Grid>
			</div>

		);
	}
}


// restaurantsSelected
const mainProps = state => {
	console.log(state.main.restaurantsSelected);
	return {
		restaurantsSelected: state.main.restaurantsSelected,
	}
}
	
export default connect(mainProps)(RestaurantsItems);




// WEBPACK FOOTER //
// ./src/components/elements/RestaurantsItems.js